export default __webpack_public_path__ + "guide--raster-imagery-4up-960-ac74785d71f91baf7d9920d2f4c1999b.png";